import { useMemo } from "react";
import { object } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { TaskTypes } from "@repo/utils";
import { useEstimateTableSettings, useTooltipHoverActions } from "@tools";
import { MenuButton, PopMenu } from "@components";
import { RowTypeButton } from "./components/RowTypeButton";
import { ExpandMore, FormatListBulletedRounded } from "@material-ui/icons";

export const SelectRowType = observer(({
  element,
}) => {
  const { t } = useTranslation();
  const { materialsSection } = useEstimateTableSettings();
  
  const {
    anchor,
    hover,
    handleHoverIn,
    handleHoverOut,
    handlePopupClose,
    handleTimeoutClear,
  } = useTooltipHoverActions();
  
  const handleRowTypeChange = (type) => () => {
    element.setType(type, true);
  }
  
  const availableTypes = useMemo(() => {
    const def = [ TaskTypes.FIXED_PRICE, TaskTypes.MATERIAL ];
    
    return materialsSection ? def : [ TaskTypes.WORKLOAD, ...def ];
  }, [ materialsSection ])
  
  return <>
    <MenuButton
      ref={anchor}
      icon={<FormatListBulletedRounded color="primary" />}
      endIcon={<ExpandMore className="-rotate-90 text-lighter" />}
      onMouseEnter={handleHoverIn}
      onMouseLeave={handlePopupClose}
    >
      {t("views.editor.row_type_change")}
    </MenuButton>
    <PopMenu
      anchor={anchor.current}
      show={hover}
      placement="right-start"
      onMouseEnter={handleTimeoutClear}
      onMouseLeave={handleHoverOut}
      offset={0}
    >
      {
        availableTypes.map((type) => (
          <RowTypeButton
            key={type}
            type={type}
            onClick={handleRowTypeChange(type)}
            checked={element.type === type}
          />
        ))
      }
    </PopMenu>
  </>;
})

SelectRowType.propTypes = {
  element: object.isRequired,
}